import { Coordinates } from 'src/app/reports/components/report/models/coordinates.model';
import { Link } from '../models/link.model';
import { LinkGroup } from '../models/link-group.model';
import { LinkElement } from '../models/link-element.model';
import { adjustCoordenateOfLinkElement } from './link.helper';
import { getCoordinateFromElement, getElementCoordinatesByMouseEvent, findAbsolutePosition } from './element-position.helper';
import { isElementValid } from './element-utils.helper';

//#region SVG Methods

export function createSVG(elm) {
  let svg : any = document.createElementNS('http://www.w3.org/2000/svg','svg');
  svg.setAttribute('style', 'position:absolute;z-index: 1');

  if(elm){
    elm.appendChild(svg);
  }

  return svg;
}

export function appendToSvg(elm : any, svg){
  svg.appendChild(elm);
}

//#endregion

export function updateCurvedLineByCircle(coordinates : Coordinates, circle : any, link: Link, group:LinkGroup, aditionFactor : number){

    if(link.firstCircle == circle){
      link.first.coordinates = coordinates;
      link.second.coordinates = getCoordinateFromElement(link.second.element, group);

      adjustCoordenateOfLinkElement(link.first, link.second, group, aditionFactor)
    }
    else {
      link.second.coordinates = coordinates;
      link.first.coordinates = getCoordinateFromElement(link.first.element, group);

      adjustCoordenateOfLinkElement(link.second, link.first, group, aditionFactor)
    }

    if(link.first.coordinates != null && link.second.coordinates != null)
      link.lineShape = drawCurvedLine(link.first.coordinates, link.second.coordinates, group, link.lineShape);
  }


export function drawCirclePlaceHolder(shape, link :LinkElement, group : LinkGroup, aditionFactor : number){
    let coordinates = getElementCoordinatesByMouseEvent(link, group, aditionFactor);
    return drawCircle(coordinates, group, shape, group.config.placeHolderColor)
}

export function drawCircle(obj : Coordinates, group : LinkGroup, shape : SVGCircleElement, color?: string) {
    let isNew : boolean = !isElementValid(shape);
    shape = isNew ? document.createElementNS('http://www.w3.org/2000/svg', 'circle') : shape;

    shape.setAttributeNS(null, 'cx', obj.x.toString());
    shape.setAttributeNS(null, 'cy', obj.y.toString());
    shape.setAttributeNS(null, 'cursor', 'pointer');
    shape.setAttributeNS(null, 'r',  group.config.radius.toString());

    if(color)
      shape.setAttributeNS(null, 'fill', color);

    if(isNew){
      appendToSvg(shape, group.svgRef);
    }

    return shape;
}

export function drawRect(obj:Coordinates, height:number, width:number, group:LinkGroup, shape, color : string = 'transparent') {
    let isNew : boolean = !isElementValid(shape);
    shape = isNew ? document.createElementNS('http://www.w3.org/2000/svg', 'rect') : shape;

    shape.setAttributeNS(null, 'x', obj.x.toString());
    shape.setAttributeNS(null, 'y', obj.y.toString());
    shape.setAttributeNS(null, 'height', height);
    shape.setAttributeNS(null, 'width', width);
    shape.setAttributeNS(null, 'fill', color);

    if(isNew){
      appendToSvg(shape, group.svgRef);
    }

    return shape;
}

export function drawSideSquares(linkElm : LinkElement, group : LinkGroup){
    let elm = linkElm.element,
        shapes = [],
        rect : DOMRect= elm.getBoundingClientRect(),
        coordinates = findAbsolutePosition(elm, group),
        size = rect.height / group.scale

    let firstCoordinates : Coordinates= {
          x: coordinates.x + (rect.width / group.scale),
          y: coordinates.y
        },
        secondCoordinates : Coordinates= {
          x: coordinates.x - size,
          y: coordinates.y
        },
        isRegistred = shapes.length > 0,
        first = drawRect(firstCoordinates, size,size, group, isRegistred ? shapes[0] : null),
        second = drawRect(secondCoordinates, size, size, group, isRegistred ? shapes[1] : null);

    if(!isRegistred){
        shapes.push(first);
        shapes.push(second);
    }else{
        shapes[0] = first;
        shapes[1] = second;
    }
}

export function drawCurvedLine(first : Coordinates, second : Coordinates, group : LinkGroup, shape : SVGPathElement, isCircleDrawed : boolean = true) :any {
    var isNew = !isElementValid(shape);
    shape = isNew ? document.createElementNS('http://www.w3.org/2000/svg', 'path') : shape;

    let delta = (second.x- first.x) * group.config.tension,
      x1  = first.x,
      hx1=first.x + delta,
      hy1=first.y,
      hx2=second.x - delta,
      hy2= second.y,
      x2 = second.x,
      path = '';

    if(isCircleDrawed){
      let radius = group.config.radius;

      if(x1 > x2){
        x1 -= radius;
        x2 += radius;
      }else{
        x1 += radius;
        x2 -= radius;
      }
    }

    path = 'M ' + x1 + ' ' + first.y + //origin
           ' C ' + hx1 + ' ' + hy1 + ' '
                 + hx2 + ' ' + hy2 + ' '
                 + x2 + ' ' + second.y; // destiny

    shape.setAttributeNS(null, 'd', path);
    shape.setAttributeNS(null, 'fill', 'none');
    shape.setAttributeNS(null, 'stroke', group.config.primaryColor);
    shape.setAttributeNS(null, 'stroke-width', group.config.lineWidth.toString());
    shape.setAttributeNS(null, 'cursor', 'pointer');

    if(isNew)
      appendToSvg(shape,group.svgRef);

    return shape;
}

export function createBlurElement(group: LinkGroup){
  let filter = document.createElementNS('http://www.w3.org/2000/svg','filter');
  filter.id='shadow';

  let dropShadow = document.createElementNS('http://www.w3.org/2000/svg', 'feDropShadow');

  dropShadow.setAttributeNS(null, 'dx', '2');
  dropShadow.setAttributeNS(null, 'dy', '1');
  dropShadow.setAttributeNS(null, 'stdDeviation', '4');
  dropShadow.setAttributeNS(null, 'flood-color', '#212020');

  appendToSvg(dropShadow,filter);
  appendToSvg(filter,group.svgRef);
}

export function registerSelectedLink(link : Link){
  this.renderer.setAttribute(link.firstCircle, 'filter', 'url(#shadow)');
  this.renderer.setAttribute(link.secondCircle, 'filter', 'url(#shadow)');
  this.renderer.setAttribute(link.lineShape, 'filter', 'url(#shadow)');
}

export function cancelSelectedLink(link : Link){
  this.renderer.removeAttribute(link.lineShape, 'filter')
  this.renderer.removeAttribute(link.firstCircle, 'filter')
  this.renderer.removeAttribute(link.secondCircle, 'filter')
}
